import type { Title } from '@/types'
import { useLibraryStore } from '@/stores/library'
import { createLogger } from '@/utils/logger'

const fileLogger = createLogger('title-completion')

export type CompletionKind = 'listen' | 'watch' | 'read'

export function completionKind(title: Title | null | undefined): CompletionKind {
  if (!title) return 'listen'

  const record = title as Title & {
    content_format?: string
    content_type?: string | { name?: string }
  }
  const format = String(record.contentFormat || record.content_format || '').toLowerCase()
  const rawType = record.content_type
  const typeName = typeof rawType === 'string' ? rawType : rawType?.name
  const type = String(typeName || '').toLowerCase()
  const mediaFormat = String(record.format || '').toLowerCase()

  if (format === 'epub' || format === 'pdf' || type === 'epub' || type === 'pdf') {
    return 'read'
  }
  if (type === 'video' || mediaFormat === 'hls' || mediaFormat === 'mp4' || mediaFormat === 'dash') {
    return 'watch'
  }
  return 'listen'
}

/** Mark a title finished and open the completion screen with suggested content. */
export async function openFinishedTitle(title: Title): Promise<void> {
  if (title?.id == null) return

  try {
    const libraryStore = useLibraryStore()
    libraryStore.played_content = libraryStore.played_content.filter(
      item => String(item.id) !== String(title.id),
    )
    void libraryStore.markTitleAsFinished(title)
  } catch (error) {
    fileLogger.error('Error updating library on finish:', error)
  }

  const { router } = await import('@/router')
  const current = router.currentRoute.value
  if (
    current.name === 'finished' &&
    String(current.params.titleId) === String(title.id)
  ) {
    return
  }

  fileLogger.log('Navigating to finished page for title:', title.id)
  await router.push({
    name: 'finished',
    params: { titleId: String(title.id) },
  })
}
